import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { CONTENT_TREE_BULK_ACTIONS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export const useHasDismissedBulkActionsChangeboardingSpotlight = () => {
	const { data } = useGetOnboardingState([
		CONTENT_TREE_BULK_ACTIONS.BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED,
	]);

	const { isBulkActionsChangeboardingSpotlightDismissed } = deserializeState(data);

	return { isBulkActionsChangeboardingSpotlightDismissed };
};
